import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, type OnInit, Output } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCircleXmark } from '@fortawesome/pro-duotone-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { LabelComponent } from '@reconcept-platform/shared/ui/standalone/label';
import { ButtonExpandableOverlayComponent } from '../button-expandable-overlay/button-expandable-overlay.component';

@Component({
  selector: 'rcp-filter-button',
  imports: [FontAwesomeModule, ButtonExpandableOverlayComponent, LabelComponent],
  templateUrl: './filter-button.component.html',
  styleUrls: ['./filter-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class FilterButtonComponent implements OnInit {
  @Input() activeFilterLabels: string[];
  @Input() defaultLabel: string;
  @Input() icon: IconProp;

  @Output() clearFilter = new EventEmitter<string[]>();

  private translateService = inject(TranslateService);

  ngOnInit() {
    if (!this.defaultLabel) {
      this.defaultLabel = this.translateService.instant('qz-filter-zm');
    }
  }

  emitClearFilter($event: MouseEvent): void {
    $event?.stopPropagation();

    this.clearFilter.emit();
  }

  protected readonly faCircleXmark = faCircleXmark;
}
